/**
 * Vela (Outstock) global configuration.
 *
 * The Outstock vendor bundle (`vendor.min.js`) and the predictive-search
 * widget both expect a `window.vela` global (settings + helpers). The
 * reference theme defined it in an early config script, but that file was
 * not ported to Metro Kitch. As a result `vendor.min.js` threw
 * "vela is not defined" on load, which aborted the rest of that bundle and
 * surfaced as a page console error on every template.
 *
 * Load this file with `defer` BEFORE `vendor.min.js` so `window.vela`
 * always exists when the vendor bundle runs.
 */
(function (w) {
  'use strict';

  w.vela = w.vela || {};

  // Settings consumed by the vendored Outstock widgets.
  if (!w.vela.settings) {
    w.vela.settings = {
      enableReview: false,
      enableQuickView: false,
      enableCartDrawer: true
    };
  }

  // A couple of helpers the vendor bundle / search widget rely on.
  if (!w.vela.debounce) {
    w.vela.debounce = function (fn, wait, immediate) {
      var timeout;
      return function () {
        var context = this, args = arguments;
        var later = function () {
          timeout = null;
          fn.apply(context, args);
        };
        var callNow = immediate && !timeout;
        timeout = setTimeout(later, wait);
        if (callNow) fn.apply(context, args);
      };
    };
  }

  if (!w.vela.throttle) {
    w.vela.throttle = function (fn, wait) {
      var last = 0, timer;
      return function () {
        var context = this, args = arguments;
        var now = Date.now();
        if (now - last >= wait) {
          last = now;
          fn.apply(context, args);
        } else {
          clearTimeout(timer);
          timer = setTimeout(function () {
            last = Date.now();
            fn.apply(context, args);
          }, wait - (now - last));
        }
      };
    };
  }
})(window);
